import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InvestigationsComponent } from './investigations.component';
import { ListModule } from './list';
import { ViewModule } from './view';
import { EditModule } from './edit';

const ROUTES: Routes = [
  {
    path: '',
    component: InvestigationsComponent,
    loadChildren: (): any => ListModule,
    pathMatch: 'full',
  },
  {
    path: 'new',
    component: InvestigationsComponent,
    loadChildren: (): any => EditModule,
    pathMatch: 'full',
  },
  {
    path: ':id/edit',
    component: InvestigationsComponent,
    loadChildren: (): any => EditModule,
    pathMatch: 'full',
  },
  {
    path: ':id',
    component: InvestigationsComponent,
    loadChildren: (): any => ViewModule,
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(ROUTES)],
  declarations: [InvestigationsComponent],
  exports: [InvestigationsComponent],
})
export class InvestigationsModule {}
